module.exports = __webpack_public_path__ + "img/vn-header.a353b63f.png";